

































import { Component, Vue, Inject } from "vue-property-decorator";
import { DelegateObjectTypes } from "@/data/enums/delegates";
import {
  ITicketProvider,
  ITicketProviderMethods
} from "@/models/providers/ticket";

@Component({
  components: {
    "delegates-provider": () =>
      import("@/components/app/global/delegates/delegatesProvider.vue"),
    "delegates-table": () =>
      import("@/components/app/global/delegates/delegatesTable.vue")
  }
})
export default class DelegateAccessModal extends Vue {
  // Injected
  @Inject({ from: "ticketProviderMethods" })
  public readonly $ticketMethods!: ITicketProviderMethods;
  @Inject({ from: "ticketProvider" })
  public readonly $ticketData!: () => ITicketProvider;
  // Computed
  public get $ticket() {
    return this.$ticketData();
  }
  public get delegatesProviderProps() {
    return {
      objectType: DelegateObjectTypes.TICKET,
      objectId: this.$ticket.ticketId
    };
  }
}
